import Accordion from "../../FLEX/components/component_accordion/accordion";

jQuery(function ($) {
    $('#fob_search select[name="year"]').on('change', function (e) {
        e.preventDefault();
        const selectedYear = $(this).val();
        $('#fob_search select[name="model"]').val('').prop('disabled', true);
        $('#fob_search select[name="make"]').val('').prop('disabled', true);

        $('#fob-search-result').html('');

        $.ajax({
                url: afp_vars.afp_ajax_url,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'get_fob_search_make',
                    year: selectedYear
                },
                success: function (response) {
                    if (response.success) {
                        var makeOptions = '<option value="">Select Make</option>';
                        $.each(response.data, function (index, post) {
                            var make = post.vehicle_terms[0];
                            if(make) {
                                makeOptions += '<option value="' + make.term_id + '">' + make.name + '</option>';
                            }
                        });
                        $('#fob_search select[name="make"]').html(makeOptions).prop('disabled', false);

                    }
                },
                error: function (xhr, status, error) {
                    console.error('AJAX Error: ', status, error);
                }
            }
        )
    });
    $('#fob_search select[name="make"]').on('change', function () {
        const selectedMake = $(this).val();
        $('#fob_search select[name="model"]').val('').prop('disabled', true);
        $('#fob-search-result').html('');
        $.ajax({
                url: afp_vars.afp_ajax_url,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'get_fob_search_model',
                    make: selectedMake,
                    selectedYear: $('#fob_search select[name="year"]').val(),
                },
                success: function (response) {
                    if (response.success) {
                        var modelOptions = '<option value="">Select Model</option>';
                        $.each(response.data, function (index, term) {
                            modelOptions += '<option value="' + term.term_id + '">' + term.name + '</option>';
                        });
                        $('#fob_search select[name="model"]').html(modelOptions).prop('disabled', false);
                    }
                },
                error: function (xhr, status, error) {
                    console.error('AJAX Error: ', status, error);
                }
            }
        )
    });
    $('#fob_search select[name="model"]').on('change', function () {
        const selectedModel = $(this).val();
        $('#fob-search-result').html('');
        $.ajax({
                url: afp_vars.afp_ajax_url,
                type: 'POST',
                data: {
                    action: 'get_product_key',
                    make: $('#fob_search select[name="make"]').val(),
                    model: selectedModel,
                    year: $('#fob_search select[name="year"]').val(),
                },
                success: function (response) {
                    if (response) {
                        $('#fob-search-result').html(response);
                        const $accordionContainer = $('.accordionContainer');
                        new Accordion($accordionContainer);
                        $('html, body').animate({
                            scrollTop: $("#fob-search-result").offset().top - 100
                        }, 1200);

                    }
                },
                error: function (xhr, status, error) {
                    console.error('AJAX Error: ', status, error);
                }
            }
        )
    });

});